<template>
  <div class="video-player-box">
    <img v-show="imgShow" src="../../../../static/images/life/videobg.jpg" />
    <div class="video-word">
      <div class="video-word-1">求真，永无止境</div>
      <div class="video-word-2">There Is No End To Seeking Truth</div>
    </div>
    <div v-show="!imgShow" class="video-player-small">
      <video-player ref="videoPlayer" :options="playerOptions" :playsinline="true" @play="onPlayerPlay($event)">
      </video-player>
    </div>
    <div class="video-player-long-box" v-show="vlIfShow">
      <div class="video-player-long-close"><i class="el-icon-close" @click="closeVideo"></i></div>
      <video-player class="video-player-long" ref="videoPlayerLong" :options="playerOptionsLong" :playsinline="true">
      </video-player>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        playerOptions: {
          muted: false, //静音
          controls: false, //取消控制功能
          preload: 'auto', //自动加载
          loop: true, //循环播放
          autoplay: true, //自动播放
          fluid: true, //自动控制大小
          sources: [{
            type: "video/mp4",
            src: '../../../../static/video/life.mp4'
          }]
        },
        playerOptionsLong: {
          muted: false, //静音
          controls: true, //取消控制功能
          preload: 'auto', //自动加载
          loop: true, //循环播放
          autoplay: false, //自动播放
          fluid: true, //自动控制大小
          sources: [{
            type: "video/mp4",
            src: '../../../../static/video/lifelong.mp4'
          }]
        },
        vlIfShow: false,
        imgShow: true
      }
    },
    mounted() {},
    methods: {
      videoClick() {
        this.vlIfShow = true;
        this.$refs.videoPlayer.player.pause();
        this.$refs.videoPlayerLong.player.play();
      },
      closeVideo() {
        this.vlIfShow = false;
        this.$refs.videoPlayer.player.play();
        this.$refs.videoPlayerLong.player.pause();
      },
      onPlayerPlay(player) {
        this.imgShow = false
      },
    }
  }
</script>
<style scoped lang="less">
  .video-player-box {
    width: 100%;
    position: relative;

    img {
      width: 100%;
      vertical-align: middle;
    }

    .video-word {
      color: #fff;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      z-index: 3;

      .video-word-1 {
        font-size: 54px;
      }

      .video-word-2 {
        font-size: 32px;
        top: 31px;
      }
    }

    .video-player-long-box {
      position: fixed;
      width: 100%;
      height: 100%;
      z-index: 10;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.6);

      .video-player-long {
        width: 85%;
        position: fixed;
        left: 50%;
        top: 50%;
        z-index: 11;
        transform: translate(-50%, -50%);
      }

      .video-player-long-close {
        width: 40px;
        height: 40px;
        position: fixed;
        top: 2%;
        right: 4%;
        z-index: 12;
        font-size: 30px;
        color: #fff;

        i:hover {
          cursor: pointer;
          color: #dcdcdc;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/life/videoPart.vue